<script setup >
import { storeToRefs } from 'pinia';
import { defineProps, watch, ref, computed } from 'vue'
import { useAssetTypesStore } from '../stores/assetTypes.js';
import { useAssetStore, rules } from '../stores/asset.js';

const assetTypesStore = useAssetTypesStore()
const assetStore = useAssetStore();
const asset = storeToRefs(assetStore);

const props = defineProps(['questionIndex']);
const questions = computed(() => {
    return assetTypesStore.getQuestionsByAssetTypeId(asset.asset_type_id.value);
});
const question = computed(() => {
    if (questions.value?.length) { 
        return questions.value[props.questionIndex];
    }
    return undefined; 
});

const questionAnswerTypes = computed (() =>{
    return question.value?.question_answer_types?.sort((a,b) => {return a.order-b.order}) ?? []
})
</script>

<template>
    <div>
        <v-card v-if="question" >
            <v-card-text>
                <h3 class="pb-2">{{question.name}}:</h3>
                <template v-for="(index) in 10"  :key="'container'+index" >
                    <v-row>
                        <KeepAlive :max="questions.length">
                            <component :index="index" v-if="questionAnswerTypes[index-1]?.answer_type" :is="questionAnswerTypes[index-1]?.answer_type.component_name" v-bind="JSON.parse(questionAnswerTypes[index-1]?.answer_type.props)" :key="question.id+questionAnswerTypes[index-1]?.answer_type.component_name" :question="question" :answerTypeId="questionAnswerTypes[index-1]?.answer_type.id"/>
                        </KeepAlive>
                    </v-row>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>